import React from 'react';
import cn from 'classnames';
import {useTranslation} from 'react-i18next';

import Icon from 'components/acommon/Icon';

import styles from './UploadFile.module.sass';

export type UploadFileProps = {
  error?: string;
  className?: string;
} & React.ComponentPropsWithRef<'input'>;

const UploadFile = React.forwardRef<HTMLInputElement, UploadFileProps>(
  ({className, type, error, ...props}, ref) => {
    const {t} = useTranslation();

    return (
      <>
        <div className={cn(styles.wrapper, className, {[styles.errorWrapper]: !!error})}>
          <input
            className={cn(styles.input)}
            type="file"
            ref={ref}
            accept="image/*"
            {...props}
          />
          <Icon className={styles.icon} name="upload-file" size="24" />
          <div className={styles.title}>{t('drag_and_drop_your_photo_here')}</div>
          <div className={styles.subtitle}>{t('or_click_to_browse')}</div>
        </div>
      </>
    );
  },
);

export {UploadFile};
